import React from 'react';
import Login from '../modules/login/Login';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import { Switch, RouteComponentProps } from 'react-router-dom';
import Dashboard from '../modules/admin/dashboard/Dashboard';
import Profile from '../modules/profile/Profile';
import Base from '../components/Base';
import Users from '../modules/user/User';
import UserProfile from '../modules/user/userProfile';
import WrappedForgotPasswordForm from '../components/ForgotPassword';
import WrappedResetPasswordForm from '../components/resetPassword';
import Sport from '../modules/master/sport/sport';
import Bonus from '../modules/master/bonus/bonus';
import Round from '../modules/master/round/round';
import Game from '../modules/master/game/game';
import Comp from '../modules/master/comp/comp';
import Team from '../modules/master/team/team';
import TeamDetail from '../modules/master/team/teamDetail';
import Topic from '../modules/cms/topic/topic';
import Question from '../modules/cms/question/question';
import Content from '../modules/cms/content/content';
import adreport from '../modules/Ad/adreport/adreport';
import Messaging from '../modules/messaging/Messaging';
import ad from '../modules/Ad/ad/ad';
import season from '../modules/master/season/season';
import seasonDetail from '../modules/master/season/seasonDetail';
import version from '../modules/version/version';
import SecretComp from '../modules/secretcomp/SecretComp';
import ChangePassword from '../modules/change-password/ChangePassword';
import article from '../modules/Article/Article';
import EditeArticle from '../modules/Article/EditeArticle';
import Banter from '../modules/BANTER/Banter';
import SettingsComp from '../modules/Settings/SettingsComp';

interface RoutesComponentProps extends RouteComponentProps {
  userInfo?: any;
}

const RoutesComponent: React.FC<RoutesComponentProps> = (props) => {
  const split = props.location.pathname.split('/');
  const value = split[2];
  const listofPages = [
    '/',
    '/signin',
    '/signup',
    '/forgot',
    '/resetPassword/' + value,
    '/verifyEmail/' + value,
    '/test'
  ];

  const token = localStorage.access_token ? true : false;

  if (listofPages.indexOf(props.location.pathname) > -1) {
    return (
      <Switch>
        <PublicRoute exact path="/" component={Login} />
        <PublicRoute path="/forgot" component={WrappedForgotPasswordForm} />
        <PublicRoute path="/resetPassword/:resetKey" component={WrappedResetPasswordForm} />
      </Switch>
    );
  } else {
    return (
      <Base>
        <Switch>
          <PrivateRoute path="/dashboard" component={Dashboard} user={token} />
          <PrivateRoute path="/profile" component={Profile} user={token} />
          <PrivateRoute path="/change-password" component={ChangePassword} user={token} />
          <PrivateRoute path="/users" component={Users} user={token} />
          <PrivateRoute path="/userprofile/:userId" component={UserProfile} user={token} />
          <PrivateRoute path="/season" component={season} user={token} />
          <PrivateRoute path="/seasondetail/:seasonId" component={seasonDetail} user={token} />
          <PrivateRoute path="/sport" component={Sport} user={token} />
          <PrivateRoute path="/team" component={Team} user={token} />
          <PrivateRoute path="/teamdetail/:teamId" component={TeamDetail} user={token} />
          <PrivateRoute path="/bonus" component={Bonus} user={token} />
          <PrivateRoute path="/round" component={Round} user={token} />
          <PrivateRoute path="/game" component={Game} user={token} />
          <PrivateRoute path="/competition" component={Comp} user={token} />
          <PrivateRoute path="/topics" component={Topic} user={token} />
          <PrivateRoute path="/questions" component={Question} user={token} />
          <PrivateRoute path="/content" component={Content} user={token} />
          <PrivateRoute path="/adreport" component={adreport} user={token} />
          <PrivateRoute path="/messaging" component={Messaging} user={token} />
          <PrivateRoute path="/ads" component={ad} user={token} />
          <PrivateRoute path="/version" component={version} user={token} />
          <PrivateRoute path="/ladder" component={article} user={token} />
          <PrivateRoute path="/secretcomp" component={SecretComp} user={token} />
          <PrivateRoute path="/settings" component={SettingsComp} user={token} />
          <PrivateRoute path="/editearticle/:id" component={EditeArticle} user={token} />
          <PrivateRoute path="/addearticle" component={EditeArticle} user={token} />
          <PrivateRoute path="/banter" component={Banter} user={token} />
        </Switch>
      </Base>
    );
  }
};

export default RoutesComponent;
